import React from 'react';

interface TemplateConfig {
  anaRenk: string;
  aksanRenk: string;
  font: string;
  fontBoyutu: number;
}

interface SpacerBlockRendererProps {
  block: { settings: Record<string, unknown> };
  config: TemplateConfig;
}

const SpacerBlockRenderer: React.FC<SpacerBlockRendererProps> = ({ block }) => {
  const s = block.settings;
  const height =
    typeof s.height === 'number' && Number.isFinite(s.height) && s.height >= 0
      ? s.height
      : 16;

  return <div style={{ width: '100%', height, flexShrink: 0 }} aria-hidden />;
};

export default SpacerBlockRenderer;
